import React from "react";
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import { formatDate } from "@telerik/kendo-intl";
import { Alert, Avatar, Button, Typography } from "@mui/material";
import { Assignment, CheckCircle } from "@mui/icons-material";
import { Stack } from "@mui/system";
import { useMyProfileQuery } from "../../../../../services/profileService/profile-api";
import { toggleEscalatedNoteResolutionModal, toggleVobRequestNoteResolutionModal } from "../../../../../app/slices/VerificationModuleSlice";

function NoteList() {
  const dispatch = useAppDispatch();
  const notes = useAppSelector(
    (state) => state.verification.verification.notes
  );
  const profile = useMyProfileQuery();
  const isManager = profile.data?.claimsAccess.find((p) => p.code === "VobManager") !== undefined;

  const convertedNotes = () => {
    let p = notes.map((obj) => {
      return { ...obj, changeDate: new Date(obj.changeDate) };
    });
    return p;
  };

  const hasUnresolvedEscalation = () => {
    const sortedNotes = convertedNotes().slice().sort((a, b) => b.changeDate.getTime() - a.changeDate.getTime());
    for (const note of sortedNotes) {
      if (note.noteText.startsWith('FACILITY REQUEST RESOLVED')) {
        return false;
      }
      if (note.noteText.startsWith('FACILITY REQUEST')) {
        return true;
      }
    }
    return false;
  };

  const hasUnresolvedVobRequest = () => {
    const sortedNotes = convertedNotes().slice().sort((a, b) => b.changeDate.getTime() - a.changeDate.getTime());
    for (const note of sortedNotes) {
      if (note.noteText.startsWith('VOB REQUEST RESOLVED')) {
        return false;
      }
      if (note.noteText.startsWith('VOB REQUEST')) {
        return true;
      }
    }
    return false;
  };

  return (
    <React.Fragment>
      {notes.length === 0 && (
        <Alert color="warning">This Case currently has no notes.</Alert>
      )}
      {isManager && hasUnresolvedEscalation() && (
        <Alert 
          severity="warning" 
          sx={{ marginBottom: '10px' }}
          action={
            <Button 
              color="success" 
              variant="contained" 
              size="small"
              startIcon={<CheckCircle />}
              onClick={() => dispatch(toggleEscalatedNoteResolutionModal())}
            >
              Resolve Request
            </Button>
          }
        >
          This case has an unresolved facility request that requires management attention.
        </Alert>
      )}
      {hasUnresolvedVobRequest() && (
        <Alert 
          severity="info" 
          sx={{ marginBottom: '10px' }}
          action={
            <Button 
              color="success" 
              variant="contained" 
              size="small"
              startIcon={<CheckCircle />}
              onClick={() => dispatch(toggleVobRequestNoteResolutionModal())}
            >
              Resolve VOB Request
            </Button>
          }
        >
          This case has an unresolved VOB request.
        </Alert>
      )}
      {convertedNotes()
        .slice()
        .sort((a, b) => b.changeDate.getTime() - a.changeDate.getTime())
        .map((i, index) => (
          <div key={`note-${index}-${i.changeDate.getTime()}`}>
            <Stack
              direction="row"
              alignItems="center"
              gap={2}
              marginLeft="10px"
            >
              <Avatar sx={{ bgcolor: i.noteText.startsWith('FACILITY REQUEST') && !i.noteText.startsWith('FACILITY REQUEST RESOLVED') ? '#d32f2f' : i.noteText.startsWith('FACILITY REQUEST RESOLVED') ? '#2e7d32' : i.noteText.startsWith('VOB REQUEST') && !i.noteText.startsWith('VOB REQUEST RESOLVED') ? '#1976d2' : i.noteText.startsWith('VOB REQUEST RESOLVED') ? '#4caf50' : undefined }}>
                <Assignment />
              </Avatar>
              <Typography>
                {i.changeBy +
                  " on " +
                  formatDate(new Date(i.changeDate ?? ""), "MM/dd/yyyy hh:mm")}
              </Typography>
            </Stack>
            <Typography marginLeft="20px">{i.noteText}</Typography>
            <hr />
          </div>
        ))}
    </React.Fragment>
  );
}

export { NoteList };
